import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { supabase } from '../lib/supabase';

const navItems = [
  { path: '/', icon: '🏠', label: 'Inicio' },
  { path: '/verse', icon: '📖', label: 'Versículo' },
  { path: '/bible', icon: '📚', label: 'Biblia' },
  { path: '/events', icon: '📅', label: 'Eventos' },
  { path: '/prayers', icon: '🙏', label: 'Oración' },
];

export default function AppLayout() {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#1C1C1E] pb-20">
      <header className="bg-[#1C1C1E] px-4 py-4 flex items-center justify-between">
        <h1 className="text-xl font-bold text-white">Brisas</h1>
        <div className="relative">
          <button
            onClick={() => setShowMenu(!showMenu)}
            className="p-2 rounded-full hover:bg-[#2C2C2E] transition-colors"
          >
            <span className="text-xl">👤</span>
          </button>
          {showMenu && (
            <div className="absolute right-0 top-full mt-2 bg-[#2C2C2E] rounded-md py-2 w-48 z-50 border border-[#3A3A3C]">
              <button
                onClick={() => { navigate('/profile'); setShowMenu(false); }}
                className="w-full text-left px-4 py-3 text-[#B3B3B3] hover:bg-[#3A3A3C] hover:text-white transition-colors"
              >
                Perfil
              </button>
              <button
                onClick={() => { navigate('/settings'); setShowMenu(false); }}
                className="w-full text-left px-4 py-3 text-[#B3B3B3] hover:bg-[#3A3A3C] hover:text-white transition-colors"
              >
                Configuración
              </button>
              <hr className="my-2 border-[#3A3A3C]" />
              <button
                onClick={handleSignOut}
                className="w-full text-left px-4 py-3 text-red-400 hover:bg-[#3A3A3C] transition-colors"
              >
                Cerrar Sesión
              </button>
            </div>
          )}
        </div>
      </header>

      <main className="p-4">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 bg-[#1C1C1E] border-t border-[#3A3A3C] pb-safe z-40">
        <div className="flex justify-around">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center py-3 px-2 text-xs transition-colors ${
                  isActive ? 'text-[#4A90D9]' : 'text-[#8E8E93]'
                }`
              }
            >
              <span className="text-xl mb-0.5">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
